import type {UpdateResourceStatusSchema} from '@cypro/engine/mutators'
import {useUpdateSupportiveMedicationStatus} from '@/modules/drug-catalog/supportive-medications/api'
import {useCan} from '@/shared/hooks/use-permissions'
import {ResourceDrawerSummary} from '@/shared/components/ui/resource-drawer-summary'
import {useSupportiveMedicationDrugContext} from '@/shared/contexts/supportive-medication-drug'
import {LuBeaker} from 'react-icons/lu'

export function SupportiveMedicationSummary() {
  const {supportiveMedicationDrug} = useSupportiveMedicationDrugContext()
  const updateStatus = useUpdateSupportiveMedicationStatus()
  const canManageCatalogue = useCan('catalogue.manage')

  return (
    <ResourceDrawerSummary
      title={supportiveMedicationDrug.name}
      description={supportiveMedicationDrug.code}
      icon={LuBeaker}
      status={supportiveMedicationDrug.status}
      {...(canManageCatalogue
        ? {
            onChangeStatus: (status: UpdateResourceStatusSchema['status']) =>
              updateStatus({id: supportiveMedicationDrug.id, status}),
          }
        : {})}
    />
  )
}
